/**
 * Place-from-source can attach the master and still return per-slot persist errors.
 * @module services/images/place-from-source-errors
 */

const SIGNED_OFF_CACHE_MISS = /not in the render cache yet/i

export function placeFromSourceSlotErrors (result) {
  if (!result) {
    return []
  }
  const errors = result.get ? result.get('errors') : result.errors
  if (!errors) {
    return []
  }
  const list = errors.toJS ? errors.toJS() : errors
  if (!Array.isArray(list)) {
    return []
  }
  return list
    .map((entry) => {
      const type = entry && (entry.type || (entry.get && entry.get('type')))
      const message = entry && (entry.message || (entry.get && entry.get('message')))
      if (!type && !message) {
        return ''
      }
      return [type, message].filter(Boolean).join(': ')
    })
    .filter(Boolean)
}

export function isSignedOffPreviewCacheMiss (message) {
  return SIGNED_OFF_CACHE_MISS.test(String(message || ''))
}

/**
 * Gen-fill cache misses are expected when the preview is still writing.
 * Copy/resize may already have succeeded on the same 201.
 */
export function partitionPlaceFromSourceSlotErrors (result) {
  const all = placeFromSourceSlotErrors(result)
  return {
    cacheMiss: all.filter(isSignedOffPreviewCacheMiss),
    hard: all.filter((message) => !isSignedOffPreviewCacheMiss(message)),
  }
}
